import React from 'react';
import { Zoom, Fab } from '@mui/material';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { CustomIcon } from 'components/CustomIcon';
import { IconType } from 'components/CustomIcon/CustomIcon.config';
import * as Styled from './ScrollFabButton.styles';

const DEFAULT_ARIA_LABEL = 'Back to top';
const DEFAULT_ICON = 'download';

interface ScrollFabButtonProps {
  onClick?: () => void;
  iconName?: IconType;
  ariaLabel?: string;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

const ScrollFabButton: React.FC<ScrollFabButtonProps> = ({
  onClick,
  iconName = DEFAULT_ICON,
  ariaLabel = DEFAULT_ARIA_LABEL,
  ...props
}) => {
  const trigger = useScrollTrigger();
  const handleClick = () => {
    onClick?.();
  };

  return (
    <Zoom in={trigger}>
      <Styled.ScrollFabContainer onClick={handleClick} {...props}>
        <Fab color="primary" size="small" aria-label={ariaLabel}>
          <CustomIcon dense name={iconName} />
        </Fab>
      </Styled.ScrollFabContainer>
    </Zoom>
  );
};

export default ScrollFabButton;
